import { TAG_SUMMARIES_SIZE } from 'app/constants/TagsConstants';

function addTags({ userId, tags }, apiClient) {
  const route = apiClient.route`/libraries/${':librarySubdomain'}/ugc/tags`;
  return apiClient.post(route, { userId, tags });
}

function removeTag({ userId, tagId, type }, apiClient) {
  const route = apiClient.route`/libraries/${':librarySubdomain'}/ugc/tags/${tagId}`;
  return apiClient.delete(route, { userId, type });
}

function fetchTagSummaries(metadataId, apiClient) {
  const route = apiClient.route`/libraries/${':librarySubdomain'}/ugc/tags/summaries`;
  return apiClient.get(route, { query: { metadataId, size: TAG_SUMMARIES_SIZE } });
}

function getUserTags(metadataIds, apiClient) {
  const route = apiClient.route`/libraries/${':librarySubdomain'}/ugc/tags/user`;
  return apiClient.get(route, { query: { metadataIds } });
}

export default {
  addTags,
  removeTag,
  fetchTagSummaries,
  getUserTags
};
